<template>
  <form @submit.prevent="newMatch">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Matchmaking</p>
      </header>
      <section class="modal-card-body">
        <b-tabs v-model="activeTab">
          <b-tab-item label="Match">

            <!-- MATCH TYPE SELECTION -->
            <b-field class="is-centered">
              <b-select v-model="match.type" placeholder="Type">
                <option value="1">Official</option>
                <option value="2" :selected="true">Regular</option>
                <option value="3">Private</option>
              </b-select>
            </b-field>
            <!-- END MATCH TYPE SELECTION -->

            <!-- PLAYER SELECTION -->
            <b-field grouped>
              <b-field label="Player 1" expanded>
                <UserSearch @select-user="onPlayer1Select"/>
              </b-field>
              <p class="has-text-black">{{ Math.abs(match.players[0].score) }} vs {{ match.players[1].score }}</p>
              <b-field label="Player 2" expanded>
                <UserSearch @select-user="onPlayer2Select"/>
              </b-field>
            </b-field>
            <!-- END PLAYER SELECTION -->

            <!-- TABLE SLIDERS -->
            <b-field grouped>
              <div class="button is-dark is-small" @click="increaseScore(0)">-{{ nextPointValue }}</div>
              <b-field expanded>
                <b-input
                  class="score"
                  v-model="match.players[0].score"
                  @mousedown.native="gobSlide(0, 'down')"
                  @mouseup.native="gobSlide(0, 'up')"
                  type="range" step="1" min="-20" max="0" value="0">
                </b-input>
              </b-field>
              <span class="table-filet"></span>
              <b-field expanded>
                <b-input
                  class="score"
                  v-model="match.players[1].score"
                  @mousedown.native="gobSlide(1, 'down')"
                  @mouseup.native="gobSlide(1, 'up')"
                  type="range" step="1" min="0" max="20" value="0">
                </b-input>
              </b-field>
              <div class="button is-dark is-small" @click="increaseScore(1)">-{{ nextPointValue }}</div>
            </b-field>
            <!-- END TABLE SLIDER -->

            <!-- TABLE FEET -->
            <div class="table-foot columns" expanded>
              <div class="button is-white column" @click="setStatusQuo(0)">{{ statusQuoButtonText }}</div>
              <div class="button is-white column" @click="setStatusQuo(1)">{{ statusQuoButtonText }}</div>
            </div>
            <!-- END TABLE FEET -->

            <!-- WINNER SELECTION -->
            <b-field label="Winner" v-if="match.players[0].user && match.players[1].user">
              <b-select v-model="match.winner" placeholder="Winner" icon="star">
                <option :value="match.players[0].user.id">{{ match.players[0].user.username }}</option>
                <option :value="match.players[1].user.id">{{ match.players[1].user.username }}</option>
              </b-select>
            </b-field>
            <!-- END WINNER SELECTION -->

          </b-tab-item>
          <b-tab-item label="History">
            <p class="has-text-black" v-for="action in match.history"
               :key="action.id">
              Player {{ action.player + 1 }}'s score decreased by {{ action.action }} due to {{ action.type }}
            </p>
          </b-tab-item>
        </b-tabs>
      </section>

      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">{{ $t('buttons.close') }}</button>
        <button class="button is-primary" :disabled="!isMatchOk">{{ $t('buttons.finish') }}</button>
      </footer>
    </div>
  </form>
</template>

<script>
import ApiMatchs from '@/api/matchs'
import UserSearch from '@/components/UserSearch'
export default {
  components: {
    UserSearch
  },
  data () {
    return {
      activeTab: 0,
      previousScore: null,
      nextPointValue: 1,
      statusQuo: false,
      match: {
        winner: null,
        type: 2,
        players: [
          {
            user: null,
            score: 0
          },
          {
            user: null,
            score: 0
          }
        ],
        history: []
      }
    }
  },
  computed: {
    scoreHasBeenTouched () {
      return !(this.match.players[0].score === 100 && this.match.players[1].score === 0)
    },
    isMatchOk () {
      return (this.match.winner && this.match.players[0].user && this.match.players[1].user && this.scoreHasBeenTouched)
    },
    statusQuoButtonText () {
      if (this.statusQuo) {
        return 'cancel'
      } else {
        return 'status-quo'
      }
    }
  },
  methods: {
    /**
     * Assign the selected user.
     */
    onPlayer1Select (user) {
      this.match.players[0].user = user
    },
    /**
     * Assign the selected user.
     */
    onPlayer2Select (user) {
      this.match.players[1].user = user
    },
    /**
     * When a gob is hit, log the action and update score.
     * @param player
     * @param type
     */
    gobSlide (player, type) {
      let score = Math.abs(this.match.players[player].score)
      if (type === 'down') {
        this.previousScore = score
      }
      if (type === 'up') {
        this.match.history.push({
          id: this.match.history.length,
          player: player,
          point: score - this.previousScore,
          type: 'gob-smash'
        })
      }
    },
    /**
     * Log action is match history, set next point value.
     * @param player
     */
    setStatusQuo (player) {
      this.statusQuo = !this.statusQuo
      if (this.statusQuo) {
        this.match.history.push({
          id: this.match.history.length,
          player: player,
          point: 0,
          type: 'status-quo'
        })
        this.nextPointValue = 2
      } else {
        this.match.history.splice(-1, 1)
        this.nextPointValue = 1
      }
    },
    /**
     * Increase the score of the player by next point value and log action.
     * @param player
     */
    increaseScore (player) {
      if (player === 0) {
        this.match.players[player].score -= this.nextPointValue
      } else {
        this.match.players[player].score = Number(this.match.players[player].score) + this.nextPointValue
      }
      this.match.history.push({
        id: this.match.history.length,
        player: player,
        point: this.nextPointValue,
        type: 'normal-point'
      })
      if (this.statusQuo) {
        this.statusQuo = !this.statusQuo
        this.nextPointValue = 1
      }
    },
    /**
     * Set players id into history, then send the new match data.
     */
    newMatch () {
      console.log('new match sending')
      var globalthis = this
      this.match.history.forEach(function (action) {
        action.player = globalthis.match.players[action.player].user.id
      })

      ApiMatchs.post.newMatch(this.match).then(response => {
        if (response.body.success) {
          this.$parent.close()
        } else {
          this.$snackbar.open({
            message: response.body.message,
            position: 'is-bottom-right',
            actionText: null
          })
        }
      })
    }
  }
}
</script>

<style>
  /* dunno why it appears white in modal */
  .dropdown-item {
    color: black !important;
  }
  .b-tabs a {
    color: black !important;
  }

  .score input {
    border: none !important;
    box-shadow: unset !important;
    border-radius: unset;
  }
  .score:focus {
    border: none !important;
  }
  .table-filet {
    border-right: solid 1px black;
    height: 28px;
    margin-top: -7px;
  }
  .table-foot {
    height: 40px;
    margin-top: -25px;
    margin-left: 10px;
    margin-right: 10px;
    border-left: solid 1px black;
    border-right: solid 1px black;
  }
</style>



// WEBPACK FOOTER //
// src/components/NewMatchForm.vue